export default __webpack_public_path__ + "static/media/ga4-bigquery-1.6b418ecf.png";